// removed by extract-text-webpack-plugin
module.exports = {"vizContainer":"vizContainer__37wJu","fact":"fact__-kAn8","alternative":"alternative__gp16l","responsive":"responsive__3Ztcv","bubbleWrap":"bubbleWrap__290nC","bubble":"bubble__3_p39","bubbleText":"bubbleText__1tqeV","label":"label__2E0e-","hidden":"hidden__1m8KE"};


//////////////////
// WEBPACK FOOTER
// ./components/CircleGraph/style.css
// module id = Zr0Q
// module chunks = 0